// import Popper


// import required js-files Bootstrap 5

// Import other js-files
/*
 * DienstAG LOS v1.0.0 (https://c3net.de)
 * Copyright 2021 Christoph Schorr
 * Licensed under the GPL-2.0-or-later license
 */
window.analyticsLoaded = false;
window.mapsLoaded = false;

window.addEventListener('cookieConsent', function (event) {
    if (event.detail.hasOption('google_tag_manager')) {
        if (false === window.analyticsLoaded) {
            window.analyticsLoaded = true;
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-TH5L8DB');
        }
    }

    <!-- Matomo -->
    if (event.detail.hasOption('matomo')) {
        var _paq = window._paq = window._paq || [];
        /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
        _paq.push(['trackPageView']);
        _paq.push(['enableLinkTracking']);
        (function () {
            var u = "https://piwik.los.de/";
            _paq.push(['setTrackerUrl', u + 'matomo.php']);
            _paq.push(['setSiteId', '1']);
            var d = document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0];
            g.type = 'text/javascript';
            g.async = true;
            g.src = u + 'matomo.js';
            s.parentNode.insertBefore(g, s);
        })();
    }
    <!-- End Matomo Code -->

    if (event.detail.hasOption('google_maps')) {
        if (false === window.mapsLoaded) {
            window.mapsLoaded = true;
            if($('body#p27').length) {
                var $links = $('.js-gme-show'),
                    $preview = $('.js-gme-preview'),
                    $mapContainer = $('.js-gme-container'),
                    useCookies = $preview.data('cookie'),
                    hideMap = true;

                console.log('load Google Maps');
                if(typeof google === "undefined") {
                    $.cookie('tx_gomapsext_show_map', 1, {path:'/'});
                    $('body').append($('<script>').attr('src', $links.data('library') + '&callback=GoMapsExtLoaded'));
                    $preview.remove();
                    setTimeout(
                        function()
                        {
                            $mapContainer.show();
                        }, 1000)

                }
            }
        }
    }


});
$(function() {

    $(window).on('load', function(e) {
        var url = window.location.href;
        var hash = url.substring(url.indexOf('#')); // '#foo'

        if(url.indexOf('#partnerKontaktformularGeneral') >= 0){
            $([document.documentElement, document.body]).animate({
                scrollTop: $('.breadcrumb').offset().top
            }, 2);
            $('.contactform .los_accordion-header').trigger('click')
        }
        if(url.indexOf('#partnerJobsuche') >= 0){
            $([document.documentElement, document.body]).animate({
                scrollTop: $('.breadcrumb').offset().top
            }, 2);
            $('.jobform .los_accordion-header').trigger('click')
        }
    });

    $('form#LosContactForm').submit(function () {
        if($(this).parsley().validate() === true) {
            $('.loading-spinner').trigger('spinner.trigger.on');
        }
    });

    $('form').parsley();

    $('.los_news-section .termine .teaser-text p, ' +
        '.los_news-section .presse .teaser-text p, ' +
        '.los_bodytext-readmore, ' +
        '.los_news-section .aktuelles .teaser-text p').readmore({
        moreLink: '<a href="#" class=""><i class="fas fa-angle-double-right me-1"></i> Erfahren Sie mehr</a>',
        lessLink: '<a href="#" class=""><i class="fas fa-angle-double-up me-1"></i> Schließen</a>',
        collapsedHeight: 66,
        speed: 200,
    });

    // WINDOW CLICK EVENT
    $(window).on('click', function(e) {
        // Read more button for news section
        if (e.target.classList.contains('los_news-card--link')) {
            let parentEl = $(e.target).parent()
            if (parentEl.hasClass('readmore')) {
                parentEl.removeClass('readmore').find('.los_news-card--description').css("height", '66px')
            } else {
                parentEl.addClass('readmore').find('.los_news-card--description').css("height", e.target.previousSibling.previousSibling.scrollHeight)
            }
        }
    });

    // WINDOW RESIZE EVENT
    $(window).resize(function () {
        if (window.innerWidth > 991) {
            $('#navbarMenu').removeClass('active');
            $('#navbarBtn').removeClass('active');
        }
    });

    // MOBILE MENU
    $('#navbarBtn').on('click', function () {
        $('#navbarMenu').toggleClass('active');
        $('#navbarBtn').toggleClass('active');
    });

    $('.los_submenu_handler').on('click', function () {
        $toggle = $(this).parent('.los_nav-item').toggleClass('open');
        $('.los_nav-item').not($toggle).removeClass('open');
    });

    $('.los_sub-submenu_handler').on('click', function () {
        $toggle = $(this).parent('.los_nav-subitem').toggleClass('open');
        $('.los_nav-subitem').not($toggle).removeClass('open');
    });

    // Accordion
    $('.los_accordion-header').on('click', function (e) {
        $('.los_accordion-item').find('.los_accordion-content').stop().slideUp();
        $(this).closest('.los_accordion-item').toggleClass('active').find('.los_accordion-content').stop().slideToggle();
    });

    $('.loading-spinner')
        .on('spinner.trigger.on', function () {
            $(this).addClass("loading-spinner--is-visible");
        })
        .on('spinner.trigger.off', function () {
            $(this).removeClass("loading-spinner--is-visible");
        });

    // Check if slider is hidden on mobile, then add padding on content
    /*
    var heightSlider = $('.los_hero-image').height();
    var heightSlider2 = $('.los_hero-image-2').height();
    if (heightSlider <= 40 || heightSlider2 <= 40){
        $('section.content').addClass('los_add_top_padding');
    }
    */

    function deUmlaut(value) {
        value = value.toLowerCase();
        value = value.replace(/ä/g, 'ae');
        value = value.replace(/ö/g, 'oe');
        value = value.replace(/ü/g, 'ue');
        value = value.replace(/ß/g, 'ss');
        value = value.replace(/ /g, '-');
        value = value.replace(/\./g, '');
        value = value.replace(/,/g, '');
        value = value.replace(/\(/g, '');
        value = value.replace(/\)/g, '');
        value = value.replace(/\?/g, '');
        value = value.replace(/\!/g, '');
        return value;
    }

    // For anchors with class listen, to scroll and change offset
    $(".listen a").click(function (e) {
        e.preventDefault();
        var targetName = $(this).attr('href');

        // check if target exists
        if ($(targetName).length > 0) {
            // change the hash of url
            window.location.hash = targetName;
            $('html, body').animate({scrollTop: $(targetName).offset().top - 120}, 0);
        } else {
            console.log('not found: ' + targetName);
        }
    })

    // Add functionality for CSS carousel
    $('.los_carousel .slide-container').each(function () {
        var indexOfIt = $(this).index() + 1;
        if (indexOfIt == 1) {
            $(this).before('<input type="radio" name="radio-buttons" id="img-' + indexOfIt + '" checked />');
        } else {
            $(this).before('<input type="radio" name="radio-buttons" id="img-' + indexOfIt + '"/>');
        }
        $('.los_carousel .los_carousel-slides .carousel-dots').append('<label for="img-' + indexOfIt + '" class="carousel-dot" id="img-dot-' + indexOfIt + '"></label>');
    });

    // Readmore Mask
    $('.los-readmore-bodytext-2').readmore({
        moreLink: '<button class="btn-readmore"><i class="fas fa-angle-double-right me-1"></i> Erfahren Sie mehr</button>',
        lessLink: '<button class="btn-readmore"><i class="fas fa-angle-double-up me-1"></i> Schließen</button>',
        collapsedHeight: 0,
        speed: 200,
    });
});
/*!
 * @preserve
 *
 * Readmore.js jQuery plugin
 * Author: @jed_foster
 * Project home: http://jedfoster.github.io/Readmore.js
 * Licensed under the MIT license
 *
 * Debounce function from http://davidwalsh.name/javascript-debounce-function
 */

/* global jQuery */

(function(factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD
        define(['jquery'], factory);
    } else if (typeof exports === 'object') {
        // CommonJS
        module.exports = factory(require('jquery'));
    } else {
        // Browser globals
        factory(jQuery);
    }
}(function($) {
    'use strict';

    var readmore = 'readmore',
        defaults = {
            speed: 100,
            collapsedHeight: 200,
            heightMargin: 16,
            moreLink: '<a href="#">Read More</a>',
            lessLink: '<a href="#">Close</a>',
            embedCSS: true,
            blockCSS: 'display: block; width: 100%;',
            startOpen: false,

            // callbacks
            blockProcessed: function() {},
            beforeToggle: function() {},
            afterToggle: function() {}
        },
        cssEmbedded = {},
        uniqueIdCounter = 0;

    function debounce(func, wait, immediate) {
        var timeout;

        return function() {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                if (! immediate) {
                    func.apply(context, args);
                }
            };
            var callNow = immediate && !timeout;

            clearTimeout(timeout);
            timeout = setTimeout(later, wait);

            if (callNow) {
                func.apply(context, args);
            }
        };
    }

    function uniqueId(prefix) {
        var id = ++uniqueIdCounter;

        return String(prefix === null ? 'rmjs-' : prefix) + id;
    }

    function setBoxHeights(element) {
        var el = element.clone().css({
                height: 'auto',
                width: element.width(),
                maxHeight: 'none',
                overflow: 'hidden'
            }).insertAfter(element),
            expandedHeight = el.outerHeight(),
            cssMaxHeight = parseInt(el.css({maxHeight: ''}).css('max-height').replace(/[^-\d\.]/g, ''), 10),
            defaultHeight = element.data('defaultHeight');

        el.remove();

        var collapsedHeight = cssMaxHeight || element.data('collapsedHeight') || defaultHeight;

        // Store our measurements.
        element.data({
            expandedHeight: expandedHeight,
            maxHeight: cssMaxHeight,
            collapsedHeight: collapsedHeight
        })
            // and disable any `max-height` property set in CSS
            .css({
                maxHeight: 'none'
            });
    }

    var resizeBoxes = debounce(function() {
        $('[data-readmore]').each(function() {
            var current = $(this),
                isExpanded = (current.attr('aria-expanded') === 'true');

            setBoxHeights(current);

            current.css({
                height: current.data( (isExpanded ? 'expandedHeight' : 'collapsedHeight') )
            });
        });
    }, 100);

    function embedCSS(options) {
        if (! cssEmbedded[options.selector]) {
            var styles = ' ';

            if (options.embedCSS && options.blockCSS !== '') {
                styles += options.selector + ' + [data-readmore-toggle], ' +
                    options.selector + '[data-readmore]{' +
                    options.blockCSS +
                    '}';
            }

            // Include the transition CSS even if embedCSS is false
            styles += options.selector + '[data-readmore]{' +
                'transition: height ' + options.speed + 'ms;' +
                'overflow: hidden;' +
                '}';

            (function(d, u) {
                var css = d.createElement('style');
                css.type = 'text/css';

                if (css.styleSheet) {
                    css.styleSheet.cssText = u;
                }
                else {
                    css.appendChild(d.createTextNode(u));
                }

                d.getElementsByTagName('head')[0].appendChild(css);
            }(document, styles));

            cssEmbedded[options.selector] = true;
        }
    }

    function Readmore(element, options) {
        this.element = element;

        this.options = $.extend({}, defaults, options);

        embedCSS(this.options);

        this._defaults = defaults;
        this._name = readmore;

        this.init();

        // IE8 chokes on `window.addEventListener`, so need to test for support.
        if (window.addEventListener) {
            // Need to resize boxes when the page has fully loaded.
            window.addEventListener('load', resizeBoxes);
            window.addEventListener('resize', resizeBoxes);
        }
        else {
            window.attachEvent('load', resizeBoxes);
            window.attachEvent('resize', resizeBoxes);
        }
    }


    Readmore.prototype = {
        init: function() {
            var current = $(this.element);

            current.data({
                defaultHeight: this.options.collapsedHeight,
                heightMargin: this.options.heightMargin
            });

            setBoxHeights(current);

            var collapsedHeight = current.data('collapsedHeight'),
                heightMargin = current.data('heightMargin');

            if (current.outerHeight(true) <= collapsedHeight + heightMargin) {
                // The block is shorter than the limit, so there's no need to truncate it.
                if (this.options.blockProcessed && typeof this.options.blockProcessed === 'function') {
                    this.options.blockProcessed(current, false);
                }
                return true;
            }
            else {
                var id = current.attr('id') || uniqueId(),
                    useLink = this.options.startOpen ? this.options.lessLink : this.options.moreLink;

                current.attr({
                    'data-readmore': '',
                    'aria-expanded': this.options.startOpen,
                    'id': id
                });

                current.after($(useLink)
                    .on('click', (function(_this) {
                        return function(event) {
                            _this.toggle(this, current[0], event);
                        };
                    })(this))
                    .attr({
                        'data-readmore-toggle': id,
                        'aria-controls': id
                    }));

                if (! this.options.startOpen) {
                    current.css({
                        height: collapsedHeight
                    });
                }

                if (this.options.blockProcessed && typeof this.options.blockProcessed === 'function') {
                    this.options.blockProcessed(current, true);
                }
            }
        },

        toggle: function(trigger, element, event) {
            if (event) {
                event.preventDefault();
            }

            if (! trigger) {
                trigger = $('[aria-controls="' + this.element.id + '"]')[0];
            }

            if (! element) {
                element = this.element;
            }

            var $element = $(element),
                newHeight = '',
                newLink = '',
                expanded = false,
                collapsedHeight = $element.data('collapsedHeight');

            if ($element.height() <= collapsedHeight) {
                newHeight = $element.data('expandedHeight') + 'px';
                newLink = 'lessLink';
                expanded = true;
            }
            else {
                newHeight = collapsedHeight;
                newLink = 'moreLink';
            }

            // Fire beforeToggle callback
            // Since we determined the new "expanded" state above we're now out of sync
            // with our true current state, so we need to flip the value of `expanded`
            if (this.options.beforeToggle && typeof this.options.beforeToggle === 'function') {
                this.options.beforeToggle(trigger, $element, ! expanded);
            }

            $element.css({'height': newHeight});

            // Fire afterToggle callback
            $element.on('transitionend', (function(_this) {
                return function() {
                    if (_this.options.afterToggle && typeof _this.options.afterToggle === 'function') {
                        _this.options.afterToggle(trigger, $element, expanded);
                    }

                    $(this).attr({
                        'aria-expanded': expanded
                    }).off('transitionend');
                };
            })(this));

            $(trigger).replaceWith($(this.options[newLink])
                .on('click', (function(_this) {
                    return function(event) {
                        _this.toggle(this, element, event);
                    };
                })(this))
                .attr({
                    'data-readmore-toggle': $element.attr('id'),
                    'aria-controls': $element.attr('id')
                }));
        },

        destroy: function() {
            $(this.element).each(function() {
                var current = $(this);

                current.attr({
                    'data-readmore': null,
                    'aria-expanded': null
                })
                    .css({
                        maxHeight: '',
                        height: ''
                    })
                    .next('[data-readmore-toggle]')
                    .remove();

                current.removeData();
            });
        }
    };


    $.fn.readmore = function(options) {
        var args = arguments,
            selector = this.selector;

        options = options || {};

        if (typeof options === 'object') {
            return this.each(function() {
                if ($.data(this, 'plugin_' + readmore)) {
                    var instance = $.data(this, 'plugin_' + readmore);
                    instance.destroy.apply(instance);
                }

                options.selector = selector;

                $.data(this, 'plugin_' + readmore, new Readmore(this, options));
            });
        }
        else if (typeof options === 'string' && options[0] !== '_' && options !== 'init') {
            return this.each(function () {
                var instance = $.data(this, 'plugin_' + readmore);
                if (instance instanceof Readmore && typeof instance[options] === 'function') {
                    instance[options].apply(instance, Array.prototype.slice.call(args, 1));
                }
            });
        }
    };

}));
// Validation errors messages for Parsley
// Load this after Parsley

Parsley.addMessages('de', {
  defaultMessage: "Die Eingabe scheint nicht korrekt zu sein.",
  type: {
    email:        "Die Eingabe muss eine gültige E-Mail-Adresse sein.",
    url:          "Die Eingabe muss eine gültige URL sein.",
    number:       "Die Eingabe muss eine Zahl sein.",
    integer:      "Die Eingabe muss eine Zahl sein.",
    digits:       "Die Eingabe darf nur Ziffern enthalten.",
    alphanum:     "Die Eingabe muss alphanumerisch sein."
  },
  notblank:       "Die Eingabe darf nicht leer sein.",
  required:       "Dies ist ein Pflichtfeld.",
  pattern:        "Die Eingabe scheint ungültig zu sein.",
  min:            "Die Eingabe muss größer oder gleich %s sein.",
  max:            "Die Eingabe muss kleiner oder gleich %s sein.",
  range:          "Die Eingabe muss zwischen %s und %s liegen.",
  minlength:      "Die Eingabe ist zu kurz. Es müssen mindestens %s Zeichen eingegeben werden.",
  maxlength:      "Die Eingabe ist zu lang. Es dürfen höchstens %s Zeichen eingegeben werden.",
  length:         "Die Länge der Eingabe ist ungültig. Es müssen zwischen %s und %s Zeichen eingegeben werden.",
  mincheck:       "Wählen Sie mindestens %s Angaben aus.",
  maxcheck:       "Wählen Sie maximal %s Angaben aus.",
  check:          "Wählen Sie zwischen %s und %s Angaben.",
  equalto:        "Dieses Feld muss dem anderen entsprechen."
});

Parsley.setLocale('de');
var losModal = document.getElementById('losModal');
if (losModal) {
    losModal.addEventListener('show.bs.modal', function (event) {
        // Button that triggered the modal
        let button = event.relatedTarget
        // Extract info from data-bs-* attributes
        var formType = button.getAttribute('data-bs-type')
        var partnerIds = button.getAttribute('data-bs-partner-ids')
        var pageId = button.getAttribute('data-bs-page-id')
        var data = {
            id: 3071,
            type: 42,
            modal: 1,
            tx_loslocations_contactform: {
                formType: formType,
                partnerIds: partnerIds,
                pageId: pageId
            }
        }

        // If necessary, you could initiate an AJAX request here
        // and then do the updating in a callback.
        $.ajax({
            url: '/index.php',
            type: 'get',
            data: data,
            beforeSend: function () {
                $('.loading-spinner').trigger('spinner.trigger.on');
            },
            success: function (response) {
                // Add response in Modal body
                $('.modal-body').html(response);
                $('.loading-spinner').trigger('spinner.trigger.off');
            }
        });
        // Update the modal's content.
        let modalTitle = losModal.querySelector('.modal-title')
        let modalBodyInput = losModal.querySelector('.modal-body input')
    });
}